import React, { useContext, useEffect } from "react";
import { contextpass } from "../App";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import portfolio from "../images/Works.png"
import Slider from "react-slick";
import WK1 from "../images/Works/WK1.jpg";
import WK2 from "../images/Works/WK2.jpg";
import WK3 from "../images/Works/WK3.jpg";
import WK4 from "../images/Works/WK4.jpg";
import WK5 from "../images/Works/WK5.jpg";
import WK6 from "../images/Works/WK6.jpg";
import WK7 from "../images/Works/WK7.jpg";
import WK8 from "../images/Works/WK8.jpg";
// import WK9 from "../images/Works/WK9.jpg";
// import WK10 from "../images/Works/WK10.jpg";
import WK11 from "../images/Works/WK11.jpg";
import WK12 from "../images/Works/WK12.jpg";
// import WK13 from "../images/Works/WK13.jpg";
import { Helmet } from "react-helmet";

function Portfolio() {
  const { pass } = useContext(contextpass);
  const [mode] = pass;

  // onscrollanimation start
  const anime1 = {
    visible: {
      opacity: 1,
      x: 0,
      transition: { ease: "easeInOut", duration: 0.9 },
    },
    hidden: { opacity: 0, x: -100 },
  };
  const anime2 = {
    visible: {
      opacity: 1,
      x: 0,
      transition: { ease: "easeInOut", duration: 0.9 },
    },
    hidden: { opacity: 0, x: 100 },
  };

  const control = useAnimation();
  const [ref, inView] = useInView();
  useEffect(() => {
    if (inView) {
      control.start("visible");
    } else {
      control.start("hidden");
    }
  }, [control, inView]);
  // onscrollanimation end

  // slider start
  const settings = {
    // dots: true,
    autoplay: true,
    autoplaySpeed: 2000,
    infinite: true,
    arrows: false,
    // lazyLoad: 'ondemand',
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  // slider end
  return (
    <section
      className={
        mode === true
          ? "align-items-center row bg-6"
          : "align-items-center row bg-4"
      }
    >
      <Helmet>
        <meta
          name="description"
          content="As a front-end developer, design and development are very important
to me. I think my technical expertise and sense of aesthetics make
me a well-rounded developer who can handle any challenge."
        />
        <title>Portfolio - Muhammed Mubashir</title>
      </Helmet>
      <motion.div
        className="col-lg-6 col-md-12 col-sm-12"
        ref={ref}
        variants={anime1}
        initial="hidden"
        animate={control}
      ><div className="inner-sec">
      <h2 className="sec-head">Portfolio</h2>
      <Slider {...settings} className="slider-div">
          <div>
            <img src={WK1} alt="" className="w-100" />
          </div>
          <div>
            <img src={WK2} alt="" className="w-100" />
          </div>
          <div>
            <img src={WK3} alt="" className="w-100" />
          </div>
          <div>
            <img src={WK4} alt="" className="w-100" />
          </div>
          <div>
            <img src={WK5} alt="" className="w-100" />
          </div>
          <div>
            <img src={WK6} alt="" className="w-100" />
          </div>
          <div>
            <img src={WK7} alt="" className="w-100" />
          </div>
          <div>
            <img src={WK8} alt="" className="w-100" />
          </div>
          {/* <div>
            <img src={WK9} alt="" className="w-100" />
          </div> */}
          {/* <div>
            <img src={WK10} alt="" className="w-100" />
          </div> */}
          <div>
            <img src={WK11} alt="" className="w-100" />
          </div>
          <div>
            <img src={WK12} alt="" className="w-100" />
          </div>
          {/* <div>
            <img src={WK13} alt="" className="w-100" />
          </div> */}
        </Slider>
    </div>
        
      </motion.div>
      <motion.div
        className="col-lg-6 col-md-12 col-sm-12 text-center"
        ref={ref}
        variants={anime2}
        initial="hidden"
        animate={control}
      >
        <img src={portfolio} alt="works" className="sec-img-w" />
      </motion.div> 
    </section>
  );
}

export default Portfolio;
